/**
 * Lightweight bus for "New deposit bonus" toasts after DepositBonusSettings
 * socket / lost-bonus claim. Consumed by DepositBonusToastHost in AppShell.
 */

export interface DepositBonusToast {
  name: string | null;
  at: number;
}

type Listener = () => void;

let latest: DepositBonusToast | null = null;
let version = 0;
const listeners = new Set<Listener>();

function notify(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function publishNewDepositBonusToast(name?: string | null): void {
  latest = { name: name?.trim() || null, at: Date.now() };
  notify();
}

export function getDepositBonusToast(): DepositBonusToast | null {
  return latest;
}

export function getDepositBonusToastVersion(): number {
  return version;
}

export function clearDepositBonusToast(): void {
  if (!latest) return;
  latest = null;
  notify();
}

export function subscribeDepositBonusToast(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
